import { Stack, type StackProps } from '@mui/material';
import { forwardRef } from 'react';

/**
 * @tier atom
 *
 * Vertical/horizontal stack with consistent gap.
 *
 * Use this — not raw `div` + flex CSS — whenever a page composes children
 * with a uniform gap.
 *
 * `direction` is a top-level prop. As of MUI v9, flexbox layout values
 * (`gap`, `alignItems`, `justifyContent`, `flexWrap`) are no longer
 * spread as system props — pass them via `sx`, which picks up
 * `theme.spacing` units: `sx={{ gap: 2 }}` (= 16px) rather than pixel literals.
 */
export type VyStackProps = StackProps;

export const VyStack = forwardRef<HTMLDivElement, VyStackProps>(
  function VyStack(props, ref) {
    return <Stack ref={ref} {...props} />;
  },
);
